import React, { createContext, useContext, useState, useEffect } from 'react';
import { createI18nContext, I18nContextType, getCurrentLanguage } from './index';

const I18nContext = createContext<I18nContextType | null>(null);

export const I18nProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [i18n, setI18n] = useState(() => createI18nContext());
  
  useEffect(() => {
    // 监听语言变化
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'app_language' && e.newValue !== i18n.language) {
        setI18n(createI18nContext());
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [i18n.language]);
  
  return (
    <I18nContext.Provider value={i18n}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = (): I18nContextType => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
}; 